<template>
  <div id="DepreciationReview">
    <div :class="`loader${loaderClass}`" v-show="loading"></div>
    <div id="page-content-wrapper" class="admin-content-area" >
      <template v-if="cantAccessPage === true">
        <div class="page-name">
          <div class="page-title">Depreciation Review</div>
          <div class="web-action-btn btn-groups text-right">
              <!-- Button for Clear Cache
              <clear-cache-data :pageKey="[pageKey]" ></clear-cache-data> -->
              <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="exportReports()">
                  <i class="fp-export"></i> Export
              </a>
          </div>
        </div>
        <div class="container-fluid">
          <div class="admin-page-content contact-list">
            <data-table-filter-config :moduleName="'depreciationReviewReport'" ref="filterComponent" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
            <div class="data-table bg-white overflow-hidden">
                <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Export file is in process. batch no. is {{batchNum}}. <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank" @click.native="batchProcess = 0"> Click Here</router-link> to check file status!</p>
                <section class="bg-white data-table">
                  <custom-pagination
                      :page-changed="onPageChange"
                      :per-page-changed="onPerPageChange" :moduleName="'depreciationReviewReport'" :position="'top'">
                  </custom-pagination>
                  <vue-good-table
                    mode="remote"
                    title="Depreciation Review"
                    ref="depreciationReviewtbl"
                    @on-page-change="onPageChange"
                    @on-sort-change="onSortChange"
                    @on-column-filter="onColumnFilter"
                    @on-per-page-change="onPerPageChange"
                    @on-select-all="onSelectAll"
                    @on-selected-rows-change="selectionChanged"
                    :totalRows="totalRecords"
                    :columns="userColumns"
                    :rows="rows"
                    :paginationOptions="{
                        enabled: false,
                        position: 'both',
                        perPage: perPage,
                        dropdownAllowAll: false,
                        setCurrentPage:listCurrentPage,
                        perPageDropdown:dropDownPerPage,
                    }"
                    :select-options="{
                        enabled: false,
                        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                        selectionInfoClass: 'custom-class',
                        selectionText: 'rows selected',
                        clearSelectionText: 'clear',
                    }"
                    :search-options="{
                    enabled: false,
                    }"

                    >
                  </vue-good-table>
                  <custom-pagination
                      :page-changed="onPageChange"
                      :per-page-changed="onPerPageChange">
                  </custom-pagination>
                </section>
            </div>
          </div>
        </div>
      </template>
      <template v-else-if="cantAccessPage === false">
        <div class="container-fluid">
          <div class="bg-white text-center">
              <h1>
                  Oops!</h1>
              <h2>
                  403 </h2>
              <div class="error-details">
                  Sorry!, You don't have permission to access this page.
              </div>
          </div>
        </div>
      </template>
      <template v-else>
        <loading-content></loading-content>
      </template>
      <app-footer></app-footer>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
 import {commonMixins} from '../../mixins/commonMixins';
 import {dataTableMixins} from '../../mixins/dataTableMixins';
export default {
  name: "DepreciationReview",
  metaInfo() {
            return {title: "Depreciation Review | " +process.env.COPYRIGHT_NAME}
        },
  mixins: [commonMixins,dataTableMixins],
  data: () => ({
    cantAccessPage:"",
    loading: false,

    permissions:[],
    rows: [],
    action: '',
    totalRecords: 0,
    userColumns:[],
    columns:
    [
      {
          label: 'Unit Number',
          field: 'unit_no',
          filterable: true,
          hidden:false,
          fpFieldType:"text",
      },
      {
          label: 'Unit Current Sts',
          field: 'status',
          fpFieldType:"option",
          filterable: true,
          hidden:false,
      },
      {
          label: 'Unit Ownership',
          field: 'ownership',
          fpFieldType:"option",
          filterable: true,
          hidden:false,
      },
      {
          label: 'On Sales List',
          field: 'on_sale',
          hidden:false,
          fpFieldType:"option",
          filterable: true,
          sortable: false,
          filterOptions: {
              enabled: false, // enable filter for this column
              placeholder: "All", // placeholder for filter input
              filterDropdownItems: ['Y','N'],
              filterValue: '', // initial populated value for this filter
              trigger: "enter" //only trigger on enter not on keyup
          },
        },
      {
          label: 'Customer Name',
          field: 'cust_name',
          fpFieldType:"text",
          filterable: true,
          hidden:false,
          sortable:false,
      },
      {
          label: 'Facility',
          field: 'location',
          fpFieldType:"option",
          filterable: true,
          hidden:false,
      },
      {
          label: 'In Service',
          field: 'service_dt',
          fpFieldType:"date",
          filterable: true,
          hidden:false,
      },
      {
          label: 'Pool',
          field: 'pool',
          fpFieldType:"option",
          filterable: true,
          hidden:false,
      },
      {
          label: 'Accum. Depr.',
          field: 'acc_dep',
          fpFieldType:"integer",
          filterable: false,
          sortable:false,
          type:'number',
          hidden:false,
      },
      {
          label: 'Weight/ SuperType',
          field: 'super_type',
          fpFieldType:"text",
          filterable: false,
          sortable:false,
          // type:'number',
          hidden:false,
      },
      {
          label: 'Cap Cost',
          field: 'capital_amount',
          fpFieldType:"integer",
          filterable: true,
          type:'number',
          hidden:false,
      },
      {
          label: 'NBV',
          field: 'nbv',
          fpFieldType:"integer",
          filterable: true,
          type:'number',
          hidden:false,
      },
      {
          label: 'Residual',
          field: 'residual',
          fpFieldType:"integer",
          type:'number',
          filterable: true,
          hidden:false,
      },
      {
          label: 'Depr Schedule Term',
          field: 'duration',
          fpFieldType:"text",
          filterable: true,
          hidden:false,
      },
      {
          label: 'Remaining Months',
          field: 'remaining_month',
          fpFieldType:"text",
          filterable: false,
          hidden:false,
          sortable:false
      },
      {
          label: 'Schedule Amount This Period',
          field: 'schd_amt_dis_period',
          fpFieldType:"integer",
          type:'number',
          filterable: true,
          hidden:false,
          sortable:true
      },
      {
          label: 'Schedule Amount Last Period',
          field: 'schd_amt_last_period',
          fpFieldType:"integer",
          type:'number',
          filterable: true,
          hidden:false,
          sortable:true
      },
      {
          label: 'Depreciation Posted This Period',
          field: 'dep_dis_period',
          fpFieldType:"integer",
          type:'number',
          filterable: true,
          hidden:false,
          sortable:true
      },
      {
          label: 'Depreciation Posted Last Period',
          field: 'dep_last_period',
          fpFieldType:"integer",
          type:'number',
          filterable: true,
          hidden:false,
          sortable:true
      },
      {
          label: 'Posting Variance',
          field: 'variance',
          fpFieldType:"integer",
          type:'number',
          filterable: false,
          hidden:false,
          sortable:false
      },
      {
          label: 'GBB Value',
          field: 'gbb_value',
          fpFieldType:"text",
          filterable: false,
          hidden:false,
          sortable:false
      },
      {
          label: 'GBB Date',
          field: 'gbb_date',
          fpFieldType:"date",
          filterable: false,
          hidden:false,
          sortable:false
      },
      {
          label: 'Serial Number',
          field: 'vin',
          fpFieldType:"text",
          filterable: true,
          hidden:false,
      },
      {
          label: 'Schedule Type',
          field: 'schedule_type',
          fpFieldType:"option",
          filterable: true,
          hidden:false,
      },
      {
        label: 'Period end date',
        field: 'end_date',
        filterable: false,
        fpMandatory : true,
        fpFieldType:"text",
        hidden:true,
    },
    ],
    batchProcess:0,
    batchNum:"",
  }),
  watch:{
    permissions: function(permission) {
        var self = this;
        permission.forEach(function (permissions) {
            if(permissions.name == 'depreciation_review') {
                self.cantAccessPage = true;
            }
        });
        if(self.cantAccessPage == ''){
            self.cantAccessPage = false;
        }
    },
  },
  mounted: function(){
    var self = this;
    self.getPermissions();
  },
  methods:{
    cancelAll: function (cancelAll) {
      this.$refs.depreciationReviewtbl.unselectAllInternal();
    },

    loadList: function(){

      var self = this;
      self.loading = true;
      var date = new Date();
      var offset = date.getTimezoneOffset();

      var selectedRows = [];
      var data = this.$refs['depreciationReviewtbl'].selectedRows;
      for ( var i = 0; i < data.length; i++ ) {
          selectedRows.push(this.$refs['depreciationReviewtbl'].selectedRows[i].id)
      }

      $.ajax({
        url: process.env.ROOT_API + "/depreciation-review-report/list",
        type: "POST",
        crossDomain: true,
        headers: this.ajxHeaders,
        dataType: "json",
        data: {
          page: self.serverParams.page,
          perPage: self.serverParams.perPage,
          filters: this.serverParams.columnFilters,
          sort: this.serverParams.sort,
          offset: offset,
          action: self.action,
          selectedAll:self.serverParams.selectedAll,
          selectedRows:selectedRows,
        },
        success: function(data) {
          self.loading = false;
          //console.log(data.content[0]["id"]);
          console.log(data.content.row);
          if (data.status == "success") {

            if ( self.action == "export" ||  self.action == "export_queue") {

                if ( data.code == "201" ) {
                    alert(data.message);
                } else {

                    if ( self.action == "export" ) {

                        self.excel = data.content.web;
                        var save = document.createElement("a");
                        save.href = self.excel;
                        save.download = data.content.web;
                        save.target = "_blank";

                        document.body.appendChild(save);
                        save.click();
                        document.body.removeChild(save);

                    } else {

                        self.batchProcess = 1;
                        self.batchNum = data.content;
                    }

                }

                self.action = "list";
                // self.loadList();
                return;

            } else {
              if (data.content.row != undefined) {
                self.rows = data.content.row;
              }
              self.totalRecords = data.content.totalRecords;
            }
          }
        },
        error: function(jqXHR, exception) {
          self.loading = false;
            self.generateStatusCodeMessage(jqXHR,true,'depreciation-review-report')
        }
      });


    }
  }

}
</script>



// WEBPACK FOOTER //
// src/components/reports/DepreciationReviewReport.vue